import { Suspense, lazy } from 'react';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const TermsOfUse = Loader(lazy(() => import('src/TermsOfUse')));
// const SharedTracking = Loader(
//   lazy(() => import('src/components/SharedTracking'))
// );
// const SharedLiveTracking = Loader(
//   lazy(() => import('src/components/SharedLiveTracking'))
// );
const PrivacyPage = Loader(lazy(() => import('src/PrivacyPage')));
// const PortChecker = Loader(lazy(() => import('src/PortChecker')));

const publicRoutes = [
  { path: 'term-of-use', element: <TermsOfUse /> },
  { path: 'privacy', element: <PrivacyPage /> },
  // {
  //   path: '/:context/share/:collectionId',
  //   element: <SharedTracking />
  // },
];

export default publicRoutes;
